import { render, staticRenderFns } from "./Reports.vue?vue&type=template&id=2aefaf1c&scoped=true"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"
import style0 from "./Reports.vue?vue&type=style&index=0&id=2aefaf1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aefaf1c",
  null
  
)

export default component.exports